import { useCallback } from "react";
import { useSendEvent } from "@/components/search/GlobalSearch/hooks/useSendEvent";
import { mainBus, QueryType } from "@/common/buses";

export const useSearchHistoryItem = () => {
  const { sendQuerySubmitted } = useSendEvent();

  const onSendMetric = useCallback((type: QueryType, value: string, itemId?: string) => {
    sendQuerySubmitted([value], type, itemId);
  }, [sendQuerySubmitted]);

  const onCloseSearch = useCallback(() => {
    mainBus.emit("close_search");
  }, []);

  const handleClick = useCallback((value: string, itemId?: string) => {
    onSendMetric("Historic", value, itemId);
    onCloseSearch();
  }, [onSendMetric, onCloseSearch]);

  return { handleClick };
};
